import React from "react";

export default function FlowContextHeader({ container }) {
  if (!container?.display_name) return null;
  return (
    <h2 className="treatment-journey-chrome__context" title={container.display_name}>
      <span aria-hidden="true">⊙</span>
      <span className="treatment-journey-chrome__context-name">{container.display_name}</span>
    </h2>
  );
}
